define('plugin/category/view/CategoryEmptyView',['require','lib/view/LayoutView'],function (require) {

	var LayoutView = require('lib/view/LayoutView');
	
	/**
	 * Category empty view
	 * 
	 * @class CategoryEmptyView
	 */
	return LayoutView.extend({

		template: '#category_empty'
	    
	});
	
});
